import { render } from "./ConsigneeInformation.vue?vue&type=template&id=4db8e454&scoped=true"
import script from "./ConsigneeInformation.vue?vue&type=script&lang=js"
export * from "./ConsigneeInformation.vue?vue&type=script&lang=js"

import "./ConsigneeInformation.vue?vue&type=style&index=0&id=4db8e454&lang=scss&scoped=true"

import exportComponent from "D:\\Word\\mingyou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db8e454"]])

export default __exports__